import { Component, OnInit, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardService } from '../dashboard.service';
import { TranslateService } from '../../../services/translate.service';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';

@Component({
  standalone: true,
  selector: 'app-uploaded-files-widget',
  imports: [CommonModule],
  templateUrl: './uploaded-files-widget.component.html',
  styleUrls: ['./uploaded-files-widget.component.scss']
})
export class UploadedFilesWidgetComponent implements OnInit {
  /**
   * Optional: pass explicit API caller name (recommended).
   * Example: <app-uploaded-files-widget callerName="UploadedFilesWidget"></app-uploaded-files-widget>
   */
  @Input() callerName?: string;

  @Input() inDialog = false; // not used here, kept for compatibility

  totalFiles: number | null = null;
  lastMonthFiles: number | null = null;
  allApiData: Record<string, any[]> = {};

  loading = false;
  error: string | null = null;

  constructor(private dashboardService: DashboardService, public translateServ : TranslateService) {}

  ngOnInit(): void {
    const caller = this.callerName ?? this.constructor.name.substring(1);
    this.loadData(caller);
  }

  loadData(caller: string) {
    this.loading = true;
    this.error = null;

    this.dashboardService.getExtendedData(caller)
      .pipe(
        catchError(err => {
          console.error('UploadedFilesWidget - API error', err);
          this.error = 'Failed to load';
          this.loading = false;
          return of(null);
        })
      )
      .subscribe((data: any) => {
        this.loading = false;
        if (!data) return;
        this.allApiData = data;
        
        // Fill values according to the API structure you posted earlier
        this.totalFiles = data?.Table?.[0]?.TotalFiles ?? 0;

        // Use Table3 for last month's data
        this.lastMonthFiles = data?.Table3?.[0]?.Total_in_Current_Month ?? 0;
      });
  }
}
